import React, { PureComponent, Suspense } from 'react';

import CreateWorkflowContainer from '@containers/workflow/crud/CreateWorkflowContainer';

import BreadCrumbs from './BreadCrumbs';
import CloseButton from './CloseButton';
import PopOver from './PopOver';

export default class ComponentStack extends PureComponent {
  state = {
    animationHasEnded: false,
  };

  addExtraProps(Component, extraProps) {
    return Component ? <Component.type {...Component.props} {...extraProps} /> : null;
  }

  renderComponent(component) {
    if (component.path) {
      const LoadedComponent = React.lazy(() =>
        import(
          `@/containers/${component.path.replace('components/', '').replace('containers/', '')}`
        )
      );

      return (
        <Suspense fallback={<></>}>
          <LoadedComponent {...component.props} />
        </Suspense>
      );
    }

    return component ? this.addExtraProps(component.component, { ...this.state }) : null;
  }

  onClose = () => {
    const { popStack } = this.props;
    popStack?.();
  };

  render() {
    const { components } = this.props;

    const componentsLength = components.length;

    return (
      <PopOver isActive={components && componentsLength > 0} onClose={() => this.onClose()}>
        <div className="component-stack">
          {components.map((component, index) => {
            return (
              <div
                className={`rightview scrollable thick ${
                  component.animateOut ? 'animateOut' : 'animateIn'
                } ${componentsLength - 1 === index ? '' : ' below'} ${
                  component.fullWidth ? ' full-width' : ''
                }`}
                key={`component-stack-${index}`}
                style={{
                  zIndex: componentsLength - 1 === index ? 10 + componentsLength : -1,
                }}
                onClick={(e) => {
                  if (componentsLength - 1 !== index) {
                    this.onClose();
                  }
                }}
                onAnimationEnd={() => {
                  this.setState({ animationHasEnded: true });
                }}
              >
                <div
                  className={`pop-up-container ${component.className ? component.className : ''}`}
                >
                  <div className="header-actions">
                    <BreadCrumbs crumbs={[]} />
                    <CloseButton onClick={() => this.onClose()} />
                  </div>
                  {this.renderComponent(component)}
                </div>
              </div>
            );
          })}
        </div>
      </PopOver>
    );
  }
}
